import React from 'react'
import { css, StyleSheet } from 'aphrodite'
import { AppTheme } from '../../../../styles/AppTheme'
import { ChatbotNodeHeader, chatbotNodeIcon } from './ChatbotNodeHeader'
import { ChatbotTargetHandle } from './ChatbotTargetHandle'
import { NODE_TYPE_START_CHATBOT } from './chatbotGraph'

const HANDLE_STYLE = {
  width: 10,
  height: 10,
  background: AppTheme.primaryColor,
  border: '2px solid #ffffff',
}

export function ChatbotStartChatbotNode(props) {
  const data = props.data || {}
  const label = String(data.chatbotLabel || data.chatbotId || '').trim()
  return (
    <div className={css(Styles.card, props.selected && Styles.cardSelected)}>
      <ChatbotTargetHandle hidden={!!data.isStartNode} style={HANDLE_STYLE} />
      <ChatbotNodeHeader
        title='Trigger Chatbot'
        icon={chatbotNodeIcon(NODE_TYPE_START_CHATBOT)}
        tone='crm'
        isStartNode={data.isStartNode}
        onDelete={data.onDelete}
        onDuplicate={data.onDuplicate}
        onSetStartNode={data.onSetStartNode}
      />
      <div className={css(Styles.body)}>
        {label ? (
          <div>
            <div className={css(Styles.rowLabel)}>Chatbot</div>
            <div className={css(Styles.value)}>{label}</div>
          </div>
        ) : (
          <div className={css(Styles.empty)}>No chatbot selected</div>
        )}
      </div>
    </div>
  )
}

const Styles = StyleSheet.create({
  card: {
    width: 240,
    backgroundColor: AppTheme.secondaryBg,
    border: '1px solid ' + AppTheme.borderColor,
    borderRadius: AppTheme.borderRadius,
    overflow: 'visible',
    boxSizing: 'border-box',
  },
  cardSelected: {
    borderColor: AppTheme.primaryColor,
    boxShadow: '0 0 0 3px ' + AppTheme.primaryColor + '33',
  },
  body: {
    padding: '10px 12px 12px',
    textAlign: 'left',
  },
  rowLabel: {
    fontSize: 11,
    lineHeight: '14px',
    fontWeight: 600,
    color: '#6B7280',
    marginBottom: 4,
  },
  value: {
    fontSize: 13,
    lineHeight: '18px',
    color: '#222222',
    wordBreak: 'break-word',
  },
  empty: {
    fontSize: 13,
    lineHeight: '18px',
    color: '#6B7280',
  },
})
